import { Navigate } from 'react-router-dom';
import {secureSessionStorage } from "store/SecureStorage";

const PrivateRoute = ({ children }) => {
    const isAuthenticated = secureSessionStorage.get('_an') === 'true';
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
